import FormController from 'controllers/form-controller';
import Rails from 'rails-ujs';
import { ezConfirm } from 'lib/modal_helpers';

export default class ResourceCommentsController extends FormController {
  static targets = [
    'commentForm',
    'commentField',
    'commentsList',
  ];

  connect() {
    super.connect();

    window.addEventListener('ToggleCommentsPanel', this.toggleCommentsPanel);

    window.addEventListener('keydown', this.escKeyTogglePanel);

    this.flagLoaded();
  }

  escKeyTogglePanel = (event) => {
    if (this.element.classList.contains('is-open') && event.key === 'Escape') {
      this.toggleCommentsPanel(event);
    }
  }

  toggleCommentsPanel = () => {
    const bodyElem = document.querySelector('body');
    bodyElem.classList.toggle('no-scroll');

    this.element.classList.toggle('is-open');
  }

  deleteComment(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    this.thisDeleteBtn = event.currentTarget;
    this.ogEvent = event;

    ezConfirm(
      this.thisDeleteBtn.getAttribute('data-confirm-text'),
      this.confirmCommentDelete,
      [
        this.thisDeleteBtn.getAttribute('data-confirm-btn-text'),
        this.thisDeleteBtn.getAttribute('data-deny-btn-text'),
      ],
    );
  }

  confirmCommentDelete = () => {
    this.thisDeleteBtn.dispatchEvent(this.ogEvent);

    this.thisDeleteBtn.addEventListener('ajax:success', this.removeComment);
  }

  removeComment = (event) => {
    const commentId = event.currentTarget.getAttribute('data-comment-id');
    const thisComment = this.element.querySelector(`.resource-comments__comment#comment_${commentId}`);

    thisComment.remove();

    if (this.commentsListTarget.childElementCount <= 0) {
      this.commentsListTarget.remove();
    }

    event.currentTarget.removeEventListener('ajax:success', this.removeComment);
  }

  validateFields(event) {
    event.preventDefault();

    super.validateFields(event);

    if (this.formValid) {
      // Remove any existing flash messages
      const flashMessages = [...this.element.querySelectorAll('[data-controller="flash-message"]')];

      if (flashMessages.length) {
        flashMessages.forEach((flash) => {
          flash.remove();
        });
      }

      Rails.fire(this.commentFormTarget, 'submit');
    }
  }
}
